import { defaultFavoriteSetId } from '#features/FavoriteSets/FavoriteSet'
import type { StoredUserData, UserDataVersion } from '#features/UserData/StoredUserData'
import { isStoredUserData_0_1_0 } from '#features/UserData/UserData_0.1.0'
import {
  type FavoriteSet_0_2_0,
  isStoredUserData_0_2_0,
  type StoredUserData_0_2_0,
  userDataVersionNumber_0_2_0,
} from '#features/UserData/UserData_0_2_0.ts'

export type CurrentStoredUserData = StoredUserData_0_2_0
export const currentStoredUserDataVersion: CurrentStoredUserData['__version'] = userDataVersionNumber_0_2_0

export function migrateUserDataToCurrent(oldData: StoredUserData<unknown, UserDataVersion>): CurrentStoredUserData {
  if (isStoredUserData_0_2_0(oldData)) {
    return oldData
  }

  if (isStoredUserData_0_1_0(oldData)) {
    const defaultFavoriteSet: FavoriteSet_0_2_0 = {
      id: defaultFavoriteSetId,
      name: 'My Favorites',
      createdAt: oldData.__updatedAt,
      entries: oldData.favorites.favorites.map((id) => ({
        id,
        createdAt: oldData.__updatedAt,
      })),
    }

    return {
      __version: currentStoredUserDataVersion,
      __updatedAt: oldData.__updatedAt,
      __type: oldData.__type,
      __maicVersion: oldData.__maicVersion,
      favorites: {
        favoriteSets: [defaultFavoriteSet],
      },
      recentManCodes: oldData.recentManCodes,
    }
  }

  throw new Error(`Unsupported user data version: ${oldData.__version}`)
}
